@if (show() && hasErrors) {
  <div 
    class="validation-summary"
    role="alert"
    aria-live="assertive"
    aria-atomic="true"
  >
    <i class="fa fa-exclamation-triangle"></i>
    
    <div class="validation-summary__content">
      <h2 class="validation-summary__title">{{ title() | translate }}</h2>
      
      <ul class="validation-summary__list">
        @for (error of errors(); track error.field) {
          <li class="validation-summary__item">
            {{ error.fieldLabel | translate }}
          </li>
        }
      </ul>
    </div>
  </div>
}
